import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { PaymentSessionResponse } from '@/lib/api/generated/models'
import { formatCurrency } from '@/lib/utils'

interface OrderSummaryProps {
  paymentSession: PaymentSessionResponse
}

const OrderSummary = ({ paymentSession }: OrderSummaryProps) => {
  const { orderDetails, totalAmount, subtotal, tax, fees, currency } = paymentSession

  return (
    <Card className="w-full max-w-md">
      <CardHeader className="bg-blue-50 text-blue-800 rounded-t-lg">
        <CardTitle>Order Summary</CardTitle>
        <CardDescription>Review your order details below.</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-4 pt-6">
        {orderDetails.lineItems.map((item, index) => (
          <div key={index} className="flex justify-between">
            <span>
              {item.name} (x{item.quantity})
            </span>
            <span>{formatCurrency(item.totalPrice, currency)}</span>
          </div>
        ))}
        <div className="border-t pt-4">
          <div className="flex justify-between">
            <span>Subtotal</span>
            <span>{formatCurrency(subtotal, currency)}</span>
          </div>
          {tax && (
            <div className="flex justify-between">
              <span>Tax</span>
              <span>{formatCurrency(tax, currency)}</span>
            </div>
          )}
          {fees && (
            <div className="flex justify-between">
              <span>Fees</span>
              <span>{formatCurrency(fees, currency)}</span>
            </div>
          )}
          <div className="flex justify-between font-bold">
            <span>Total</span>
            <span>{formatCurrency(totalAmount, currency)}</span>
          </div>
        </div>
      </CardContent>
      <CardFooter>
        <p className="text-sm text-gray-500">Powered by FanFair</p>
      </CardFooter>
    </Card>
  )
}

export default OrderSummary
